module.exports = __webpack_public_path__ + "img/pm.cb609837.svg";